import { Platform } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

const CUSTOM_TAB_BAR_CONTENT_HEIGHT = 64

export default function useCustomTabBarHeight() {
  const insets = useSafeAreaInsets()

  if (Platform.OS === 'ios') return 0

  return CUSTOM_TAB_BAR_CONTENT_HEIGHT + Math.max(insets.bottom, 8)
}
